<template>
  <el-dialog v-el-drag-dialog :visible.sync="innerVisible" :title="$t('queryJob.exportOption')" width="400px" :close-on-click-modal="false">
    <div style="display: flex;height: 50px;align-items: center;padding-left: 10px;">
      <el-checkbox v-model="isExportOperation">{{ $t('queryJob.exportDescription') }}</el-checkbox>
      <el-checkbox v-model="isMergeGroup">{{ $t('queryJob.dataNotMerged') }}</el-checkbox>
    </div>
    <div slot="footer">
      <el-checkbox v-model="notRemindExportOperation" style="float: left;margin: 5px 0 0 10px;">{{ $t('queryJob.noMoreReminders') }}</el-checkbox>
      <el-button type="primary" @click="okHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export default {
  name: 'ExportOperationDialog',
  props: {
    visible: { type: Boolean, required: true },
    prefix: { type: String, default: '' }
  },
  data() {
    return {
      innerVisible: false,
      notRemindExportOperation: false,
      isExportOperation: false,
      isMergeGroup: false
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.notRemindExportOperation = LocalStorageUtilsNew.getConfiguration(this.prefix + 'NOT_REMIND_EXPORT_OPERATION') || false
          this.isExportOperation = LocalStorageUtilsNew.getConfiguration(this.prefix + 'IS_EXPORT_OPERATION') || false
          this.isMergeGroup = LocalStorageUtilsNew.getConfiguration(this.prefix + 'IS_MERGE_GROUP') || false
        }
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.saveConfig()
      }
    }
  },
  methods: {
    okHandler() {
      this.saveConfig()
      this.innerVisible = false
      this.$emit('export')
    },
    saveConfig() {
      LocalStorageUtilsNew.setConfiguration(this.prefix + 'NOT_REMIND_EXPORT_OPERATION', this.notRemindExportOperation)
      LocalStorageUtilsNew.setConfiguration(this.prefix + 'IS_EXPORT_OPERATION', this.isExportOperation)
      LocalStorageUtilsNew.setConfiguration(this.prefix + 'IS_MERGE_GROUP', this.isMergeGroup)
    }
  }
}
</script>
